<template>
  <div class="device-manage">
    <div class="device-manage-content">
      <filter-bar
        :itemArray="itemArray"
        :initialSelectedIndex="selectedComponentIndex"
        :buttonTitle="filterBarButtonTitle"
        keywordTitle="姓名或手机号"
        v-model="keyword"
        @onItemSelected="onItemSelected"
        @onButtonClick="onAddDeviceClick"
        @onSearchClick="onSearchClick"
        @onSearch="onSearch"
        @onDurationSelected="onDurationSelected"
        @onPushStatusChange="onPushStatusChange"
      />
      <div class="file">
        <div class="file-content">
          <page-list-container
            class="file-content-bottom"
            :total="total"
            :pageSize="pageSize"
            :inputCurrentPage="currentPage"
            @onPageChange="onPageChange"
            @onSizeChange="onSizeChange"
          >
            <el-table
              :data="fileArray"
              height="100%"
              @row-click="onRowClick"
              :row-class-name="getRowClassName"
              :row-style="{ height: '54px' }"
              :cell-style="{ height: '54px', padding: '0' }"
              style="width: 100%"
            >
              <el-table-column
                prop="trueName"
                label="姓名"
               
                show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  {{ getDisplayName(row.trueName) }}
                </template>
              </el-table-column>

              <el-table-column
                prop="sex"
                label="性别"
                width="60"
                show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  {{ formatGender(row.sex) }}
                </template>
              </el-table-column>

              <el-table-column
                prop="age"
                label="年龄"
                width="60"
                show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  {{ formatAge(row.age) }}
                </template>
              </el-table-column>
              
              <el-table-column
                prop="mobile"
                label="手机号"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  {{ getDisplayMobile(row.mobile) }}
                </template>
              </el-table-column>
              
              <el-table-column
                prop="appointmentDate"
                label="预约日期"
               
              >
                <template slot-scope="{ row }">
                  {{ formatStorageTime(row.appointmentDate) }}
                </template>
              </el-table-column>
              
              <el-table-column
                prop="deviceSn"
                label="预绑信息"
               
                show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  {{ placeholderText(row.deviceSn) }}
                </template>
              </el-table-column>
              
              <el-table-column
                prop="status"
                label="状态"
                
              >
                <template slot-scope="{ row }">
                  <span :style="{ color: getStatusColor(row.status) }">
                    {{ formatAppointmentStatus(row.status) }}
                  </span>
                </template>
              </el-table-column>
              
              <el-table-column
                prop="remark"
                label="备注"
               
                show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  {{ placeholderText(row.remark) }}
                </template>
              </el-table-column>
              
              <el-table-column
                prop="hospitalName"
                label="机构名称"
                
              >
                <template slot-scope="{ row }">
                  {{ placeholderText(row.hospitalName) }}
                </template>
              </el-table-column>
              
              <el-table-column
                width="180"
              >
                <template slot="header">
                  操作
                </template>
                <template slot-scope="{ row }">
                  <div class="operation-buttons">
                    <el-button
                      type="text"
                      size="small"
                      :style="getCancelButtonStyle(row)"
                      @click="onCancelClick(row)"
                    >
                      预约取消
                    </el-button>
                    <el-button
                      type="text"
                      size="small"
                      :style="getEditButtonStyle(row)"
                      @click="onEditClick(row)"
                    >
                      编辑
                    </el-button>
                    <el-button
                      v-if="row.status === 2"
                      type="text"
                      size="small"
                      class="bind-button"
                      style="color: #325fac !important; cursor: pointer;"
                      @click="onBindClick(row)"
                    >
                      实绑
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </page-list-container>
        </div>
      </div>
    </div>
    <file-add
      v-if="isShowAddDevice"
      :editData="editData"
      :hospitalId="hospitalID"
      @onCloseClick="onAddDeviceCloseClick"
      @onConfirmClick="onAddDeviceConfirmClick"
    >
    </file-add>
    
    <appointment-bind
      :isShowAlert="isShowBindAlert"
      :appointmentData="bindAppointmentData || {}"
      @onIsShowAlertChanged="onBindAlertClose"
      @onBindComplete="onBindComplete"
    >
    </appointment-bind>
  </div>
</template>

<script>
import FilterBar from "@c/monitoring-appointments/filter-bar.vue";
import PageListContainer from "@c/operation-log/common/paging-list/page-list-container.vue";
import FileAdd from "@c/monitoring-appointments/file-add.vue";
import AppointmentBind from "@c/monitoring-appointments/appointment-bind.vue";

import { CacheTool } from "@js/cache-tool.js";
import { DateTool } from "@js/date-tool.js";
import {
  getDisplayName,
  getDisplayMobile,
} from "@js/anonymization-tool.js";
export default {
  components: {
    FilterBar,
    PageListContainer,
    FileAdd,
    AppointmentBind,
  },

  data() {
    return {
      selectedComponentIndex: 0,
      keyword: "",
      itemArray: ["监护仪", "监护仪绑定指环", "儿童OSA绑定指环"],
      filterBarButtonTitle: undefined,
      canDeleteDevice: undefined,
      fileArray: [],
      total: undefined,
      pageSize: undefined,
      currentPage: 1,
      keywords: "",
      searchConditions: {
        trueName: undefined,
        mobile: undefined,
        appointmentDate: undefined,
        status: undefined,
        remark: undefined,
        keyword: undefined,
        startTime: undefined,
        endTime: undefined
      },
      selectedModel: undefined,
      isShowAddDevice: false,
      isShowEditDevice: false,
      editData: null,
      isViewMode: false,
      isShowOutboundDevice: false,
      isShowRoamDevice: false,
      isShowLogDevice: false,
      hospitalList: [],
      isShowBindAlert: false,
      bindAppointmentData: null,
    };
  },

  computed: {
    hospitalID: function () {
      return this.$store.state.selectedHospital.hospitalid;
    },

    selectedID() {
      return this.selectedModel == undefined
        ? undefined
        : this.selectedModel.id;
    },
    
    isSeniorAdministrator() {
      return this.$store.getters.isSeniorAdministrator;
    },
  },

  async mounted() {
    this.pageSize = this.bestPageSizeComputer();
    await this.getLatestUserInfo();
    this.getFilterBarButtonTitle();
    this.canDeleteDevice = this.$store.state.accountInfo.deviceManagement;
    await this.getHospitalList();
    this.fileListRequest();
  },

  watch: {
    hospitalID: function () {
      if (this.$store.state.accountInfo) {
        this.currentPage = 1;
        this.fileListRequest();
      }
    },

    selectedComponentIndex() {
      this.getFilterBarButtonTitle();
    },
  },

  methods: {
    getCancelButtonStyle(row) {
      const canCancel = row.status === 1 || row.status === 2;
      return canCancel 
        ? "color: #325fac !important; cursor: pointer;"
        : "cursor: not-allowed;color:#C1C1C1 !important;";
    },
    
    getEditButtonStyle(row) {
      const canEdit = row.status === 1;
      return canEdit 
        ? "color: #325fac !important; cursor: pointer;"
        : "cursor: not-allowed;color:#C1C1C1 !important;";
    },

    formatAge(age) {
      if (age === null || age === undefined || age === "null" || age === "") {
        return "-";
      }
      return age;
    },
    
    bestPageSizeComputer() {
      return 10;
    },

    onItemSelected(index) {
      this.selectedComponentIndex = index;
      this.keyword = undefined;
    },

    onSearchClick(value) {
      this.currentPage = 1;
      this.keywords = value || "";
      // 清空其他搜索条件，只保留关键词搜索
      this.searchConditions = {
        ...this.searchConditions,
        trueName: undefined,
        mobile: undefined,
        keyword: value || ""
      };
      this.fileListRequest();
    },
    
    onSearch(conditions) {
      this.currentPage = 1;
      this.searchConditions = conditions;
      this.keywords = conditions.keyword || "";
      this.fileListRequest();
    },

    onDurationSelected(duration) {
      this.currentPage = 1;
      if (duration && duration.length === 2) {
        // duration 是时间戳数组 [开始时间戳, 结束时间戳]
        const startTime = new Date(duration[0]);
        const endTime = new Date(duration[1]);
        
        // 格式化为 YYYY-MM-DD
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };
        
        this.searchConditions.startTime = formatDate(startTime);
        this.searchConditions.endTime = formatDate(endTime);
      } else {
        // 清空日期筛选
        this.searchConditions.startTime = undefined;
        this.searchConditions.endTime = undefined;
      }
      this.fileListRequest();
    },

    onPushStatusChange(status) {
      this.currentPage = 1;
      // status 为 0 表示"全部"，应该清空状态筛选
      this.searchConditions.status = status === 0 ? undefined : status;
      this.fileListRequest();
    },

    onAddDeviceClick() {
      if(!this.hospitalID){
        this.$toast.showRed('请先选择医院机构')
        return
      }
     

      this.isShowAddDevice = true;
    },

    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.fileListRequest();
    },

    onSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fileListRequest();
    },

    onCellSelectClick(model) {
      this.selectedModel = model;
    },

    onStopClick() {
      this.$alert.show("设备操作", "是否要终止监测？", () => {
        this.deviceStopRequest();
      });
    },

    onAddUserClick() {
      this.$emit("onAddUserClick", this.selectedModel);
    },

    onDeleteClick() {
      this.$alert.show("设备操作", "是否要删除设备？", () => {
        this.deviceDeleteRequest();
      });
    },

    onEditClick(row) {
      if (row.status !== 1) {
        return;
      }
      if (row) {
        this.selectedModel = row;
        this.editData = row;
      }
      this.isViewMode = false;
      this.isShowAddDevice = true; // 复用新增弹窗
    },
    onCancelClick(row){
      if (row.status !== 1 && row.status !== 2) {
        return;
      }
      this.$alert.show("预约操作", "是否要取消预约？", () => {
        this.cancelAppointmentRequest(row);
      });
    },

    onBindClick(row) {
      // 显示绑定弹框
      console.log('点击绑定按钮', row); // 调试用
      this.bindAppointmentData = row;
      this.isShowBindAlert = true;
      console.log('绑定弹框状态', this.isShowBindAlert); // 调试用
    },

    onBindAlertClose(value) {
      this.isShowBindAlert = value || false;
      if (!value) {
        this.bindAppointmentData = null;
      }
    },

    onBindComplete(error) {
      this.isShowBindAlert = false;
      this.bindAppointmentData = null;
      
      if (error) {
        this.$toast.showRed(error);
      } else {
        this.$toast.showGreen("设备绑定成功");
        // 刷新列表
        this.fileListRequest();
        // 触发预约数量更新事件
        this.$emit('onAppointmentCountChanged');
      }
    },

    async cancelAppointmentRequest(row) {
      try {
        const params = {
          id: row.id,
          userId: row.userId,
          appointmentDate: row.appointmentDate,
          remark: row.remark,
          status: 5, // 手动取消
          hospitalId: this.hospitalID,
        };
        
        await this.$api.getMonitoringAppointmentsUpdate(params);
        this.$toast.showGreen("预约取消成功");
        this.fileListRequest();
        // 触发预约数量更新事件
        this.$emit('onAppointmentCountChanged');
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    onDeviceArchiveClick(row) {
      this.selectedModel = row;
      this.isViewMode = true;
      this.isShowEditDevice = true;
    },

    onDeviceOutboundClick(row) {
      this.selectedModel = row;
      this.isShowOutboundDevice = true;
    },

    onDeviceRoamClick(row) {
      this.selectedModel = row;
      this.isShowRoamDevice = true;
    },

    onDeviceLogClick(row) {
      this.selectedModel = row;
      this.isShowLogDevice = true;
    },

    onRowClick(row) {
      this.selectedModel = row;
    },

    getRowClassName({ row }) {
      return this.selectedModel && this.selectedModel.id === row.id ? 'selected-row' : '';
    },

    onRecycleDeviceClick(selectedModel) {
      this.$emit("onRecycleDeviceClick", selectedModel);
    },

    formatGender(sex) {
      switch (sex) {
        case 1:
          return "男";
        case 2:
          return "女";
        default:
          return this.placeholderText("");
      }
    },

    placeholderText(rawValue, unitText = "") {
      if (!rawValue || rawValue === "null") {
        return "-";
      } else {
        const finalUnitText = unitText ? ` ${unitText}` : "";
        return `${rawValue}${finalUnitText}`;
      }
    },

    getDisplayName(value) {
      return getDisplayName(value, this.$store.state.accountInfo);
    },

    getDisplayMobile(value) {
      return getDisplayMobile(value, this.$store.state.accountInfo);
    },

    formatStorageTime(inboundTime) {
      return this.placeholderText(
        DateTool.formatDate(
          DateTool.strToDate(inboundTime),
          "Y-M-D"
        )
      );
    },

    formatValidityPeriod(expiryDate) {
      return this.placeholderText(
        expiryDate ? 
        DateTool.formatDate(
          DateTool.strToDate(expiryDate),
          "Y-M-D"
        ) : ""
      );
    },

    formatDeviceProperty(deviceAttribute) {
      switch (deviceAttribute) {
        case 1:
          return "正式进院";
        case 2:
          return "试用";
        default:
          return this.placeholderText("");
      }
    },

    formatDeviceStatus(deviceStatus) {
      switch (deviceStatus) {
        case 1:
          return "在库";
        case 2:
          return "已售";
        case 3:
          return "流转中";
        case 4:
          return "故障维修";
        case 5:
          return "废弃";
        case 6:
          return "丢失";
        default:
          return this.placeholderText("");
      }
    },

    formatWarrantyPeriod(outboundTime, warrantyYears, deviceAttribute) {
      // 如果设备属性为试用（2），显示"-"
      if (deviceAttribute === 2) {
        return "-";
      }
      
      // 如柩设备属性为正式进院（1）
      if (deviceAttribute === 1) {
        // 如果没有质保年数，显示"待补充"
        if (!warrantyYears) {
          return "待补充";
        }
        
        // 如果没有出库时间但有质保年数，也显示"待补充"
        if (!outboundTime) {
          return "待补充";
        }
        
        // 如果都有，计算合同质保期
        try {
          const outboundDate = DateTool.strToDate(outboundTime);
          const warrantyendTime = new Date(outboundDate);
          warrantyendTime.setFullYear(warrantyendTime.getFullYear() + warrantyYears);
          
          return DateTool.formatDate(warrantyendTime, "Y-M-D");
        } catch (error) {
          return "待补充";
        }
      }
      
      // 其他情况显示"-"
      return this.placeholderText("");
    },

    formatCurrentScenario(currentScenario) {
      switch (currentScenario) {
        case 0:
          return "-";
        case 1:
          return "睡眠监测";
        case 2:
          return "初筛";
        default:
          return "-";
      }
    },

    formatAppointmentStatus(status) {
      switch (status) {
        case 1:
          return "已预约";
        case 2:
          return "待监测";
        case 3:
          return "已完成";
        case 4:
          return "预约超时";
        case 5:
          return "手动取消";
        default:
          return this.placeholderText("");
      }
    },

    getStatusColor(status) {
      switch (status) {
        case 1:
          return "#596AFD"; // 已预约
        case 2:
          return "#F39920"; // 待监测
        case 3:
          return "#6CC291"; // 已完成
        case 4:
          return "#F45C50"; // 预约超时
        case 5:
          return "#F45C50"; // 手动取消
        default:
          return "#666666"; // 默认颜色
      }
    },

    onAddDeviceCloseClick() {
      this.isShowAddDevice = false;
      this.editData = null;
    },

    onAddDeviceConfirmClick(info) {
      this.isShowAddDevice = false;
      if (this.editData) {
        // 编辑模式
        this.fileEditRequest(info);
      } else {
        // 新增模式
        this.fileAddRequest(info);
      }
      this.editData = null;
    },

    onEditDeviceCloseClick() {
      this.isShowEditDevice = false;
      this.isViewMode = false;
    },

    onEditFileConfirmClick(info) {
      this.isShowEditDevice = false;
      this.isViewMode = false;
      this.fileEditRequest(info);
    },

    onLostClick(model) {
      this.$alert.show("设备操作", "是否要标记设备为丢失？", () => {
        this.deviceLostRequest(model);
      });
    },

    onDiscardClick(model) {
      this.$alert.show("设备操作", "是否要标记设备为废弃？", () => {
        this.deviceDiscardRequest(model);
      });
    },

    onOutboundDeviceCloseClick() {
      this.isShowOutboundDevice = false;
    },

    onOutboundDeviceConfirmClick(info) {
      this.isShowOutboundDevice = false;
      this.deviceOutboundRequest(info);
    },

    onRoamDeviceCloseClick() {
      this.isShowRoamDevice = false;
    },

    onRoamDeviceConfirmClick(info) {
      this.isShowRoamDevice = false;
      this.deviceRoamRequest(info);
    },

    onLogDeviceCloseClick() {
      this.isShowLogDevice = false;
    },

    async fileListRequest() {
      try {
        const params = {
          pageNum: this.currentPage || 1,
          pageSize: this.pageSize || 10,
          trueName: this.searchConditions.trueName,
          mobile: this.searchConditions.mobile,
          appointmentDate: this.searchConditions.appointmentDate,
          status: this.searchConditions.status,
          remark: this.searchConditions.remark,
          startTime: this.searchConditions.startTime,
          endTime: this.searchConditions.endTime,
          keyword: this.keywords, // 关键词搜索（姓名或手机号）
          hospitalId: this.hospitalID,
        };
        
        // 过滤掉 undefined 的参数
        Object.keys(params).forEach(key => {
          if (params[key] === undefined || params[key] === '') {
            delete params[key];
          }
        });
        
        console.log('查询参数', params); // 调试用
        const response = await this.$api.getMonitoringAppointmentsList(params);
        this.total = response.total;
        this.fileArray = response.list;
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async deviceDeleteRequest() {
      try {
        const params = {
          id: this.selectedModel.id,
        };
        await this.$api.deleteDevice(params);
        this.$toast.showGreen(MSG.deviceDeleteSucceed);
        this.fileListRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async deviceStopRequest() {
      try {
        const params = {
          id: this.selectedModel.id,
        };
        await this.$api.stopDevice(params);
        this.fileListRequest();
        this.$toast.showGreenLink("操作成功，", "点此马上去回收设备！", () => {
          this.$emit("onRecycleDeviceClick", this.selectedModel);
        });
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async fileAddRequest(info) {
      try {
        const params = {
          userId: info.userId,
          appointmentDate: info.appointmentDate,
          remark: info.remark,
          deviceSn: info.deviceSn,
          hospitalId: this.hospitalID,
        };
        
        await this.$api.getMonitoringAppointmentsSave(params);
        this.$toast.showGreen("预约添加成功");
        this.currentPage = 1;
        this.keywords = "";
        this.fileListRequest();
        // 触发预约数量更新事件
        this.$emit('onAppointmentCountChanged');
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async fileEditRequest(info) {
      try {
        // 如果是预约编辑
        if (info.hasOwnProperty('appointmentDate')) {
          const params = {
            id: info.id,
            userId: info.userId,
            appointmentDate: info.appointmentDate,
            remark: info.remark,
            deviceSn: info.deviceSn,
            hospitalId: this.hospitalID,
          };
          
          await this.$api.getMonitoringAppointmentsUpdate(params);
          this.$toast.showGreen("预约编辑成功");
          this.fileListRequest();
          // 触发预约数量更新事件
          this.$emit('onAppointmentCountChanged');
          return;
        }
        
        // 原有的设备编辑逻辑
        let params = {};
        
        if (info.hasOwnProperty('outboundTime') || info.hasOwnProperty('warrantyYears')) {
          params = {
            id: info.id,
            deviceAttribute: info.deviceAttribute,
            deviceStatus: info.deviceStatus,
            outboundPersonId: info.outboundPersonId,
            outboundHospitalId: info.outboundHospitalId,
            outboundTime: info.outboundTime,
            warrantyYears: info.warrantyYears,
            contractNumber: info.contractNumber,
            contractSignatory: info.contractSignatory,
            outboundRemarks: info.outboundRemarks,
          };
        } else {
          params = {
            id: info.id,
            model: info.model,
            deviceTypeId: info.deviceTypeId,
            deviceSn: info.deviceSn,
            ringType: info.ringType,
            productionDate: info.productionDate,
            expiryDate: info.expiryDate,
            batchNumber: info.batchNumber,
            trafficCardId: info.trafficCardId,
            deviceNature: info.deviceNature,
            deviceStatus: info.deviceStatus,
            inboundRemarks: info.inboundRemarks,
          };
        }
        
        await this.$api.getEquipmentFileUpdate(params);
        this.$toast.showGreen(MSG.deviceEditSucceed);
        this.fileListRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async deviceLostRequest(model) {
      console.log('设备丢失功能待实现');
    },

    async deviceDiscardRequest(model) {
      console.log('设备废弃功能待实现');
    },

    async deviceOutboundRequest(info) {
      try {
        const params = {
          id: this.selectedModel.id,
          deviceAttribute: info.deviceAttribute,
          deviceStatus: info.deviceStatus,
          outboundRingIds: info.outboundRingIds,
          outboundPersonId: info.outboundPersonId,
          outboundHospitalId: info.outboundHospitalId,
          outboundTime: info.outboundTime,
          warrantyYears: info.warrantyYears,
          contractNumber: info.contractNumber,
          contractSignatory: info.contractSignatory,
          outboundRemarks: info.outboundRemarks,
        };
        await this.$api.getEquipmentFileUpdate(params);
        this.$toast.showGreen("设备出库成功");
        this.fileListRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async deviceRoamRequest(info) {
      try {
        const params = {
          id: this.selectedModel.id,
          deviceAttribute: info.deviceAttribute,
          deviceStatus: info.deviceStatus,
          outboundRingIds: info.outboundRingIds,
          outboundPersonId: info.outboundPersonId,
          outboundHospitalId: info.outboundHospitalId,
        };
        await this.$api.getEquipmentFileUpdate(params);
        this.$toast.showGreen("设备流转成功");
        this.fileListRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async getFilterBarButtonTitle() {
      if (this.selectedComponentIndex == 2) {
        this.filterBarButtonTitle = null;
      } else {
        this.filterBarButtonTitle = "新增预约";
      }
    },

    async getLatestUserInfo() {
      try {
        const loginInfo = CacheTool.getLoginInfo();
        const params = { id: loginInfo.uid };
        const response = await this.$api.userInfo(params);
        const currentAccountInfo = this.$store.state.accountInfo || {};
        const responseHasAnonymization = Object.prototype.hasOwnProperty.call(
          response,
          "anonymization"
        );
        const nextAccountInfo = {
          ...currentAccountInfo,
          ...response,
          anonymization: responseHasAnonymization
            ? response.anonymization
            : currentAccountInfo.anonymization,
        };
        if (
          nextAccountInfo.deviceManagement == currentAccountInfo.deviceManagement &&
          nextAccountInfo.anonymization === currentAccountInfo.anonymization
        ) {
          return;
        }
        this.$store.commit("saveAccountInfo", nextAccountInfo);
      } catch {}
    },

    async getHospitalList() {
      try {
        const params = {
          parentId: this.$store.state.accountInfo.id
        };
        const response = await this.$api.getHospitalList(params);
        
        this.hospitalList = response.map((item) => {
          return {
            value: item.id,
            label: item.hospitalName
          };
        });
      } catch (error) {
        console.error('获取机构列表失败:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.device-manage {
  background-color: #eff2f7;

  &-content {
    background-color: white;
    box-sizing: border-box;
    padding: 0 20px;
    flex: 1;
  }
}

.file {
  &-content {
    background-color: white;
    border-radius: rem(2);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    &-top {
      font-size: rem(16);
      width: 100%;
      height: rem(59);
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      &-left {
        display: flex;

        &-title {
          color: #325fac;
          font-size: rem(14);
          border-bottom: rem(2) solid #325fac;
          width: rem(100);
          height: rem(32);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &-add-device {
          color: white;
          background-color: #325fac;
          font-size: rem(14);
          width: rem(88);
          height: rem(32);
          border-radius: 4px;
          margin-left: rem(74);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    &-bottom {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .bind-button{
        font-weight: normal;
        font-size: 14px;
        color: #325FAC;
        line-height: 22px;
        text-align: center;
        font-style: normal;
        text-decoration-line: underline;
        text-transform: none;
        cursor: pointer;
      }

      &-list {
        width: 100%;
      }

      &-empty-info {
        color: rgba($color: black, $alpha: 0.85);
        font-size: rem(14);
        width: 100%;
        margin-top: rem(100);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-pagination {
        width: 100%;
        height: rem(90);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.operation-buttons {
  display: flex;
  flex-wrap: nowrap;
  gap: rem(4);
  justify-content: center;
  
  .el-button {
    padding: rem(4) rem(8) !important;
    font-size: rem(12) !important;
    line-height: 1 !important;
    min-width: auto !important;
  }
  
  .el-button--primary {
    color: #FFF !important;
    background-color: #5967fd !important;
    border-color: #5967fd !important;
    
    &:hover,
    &:focus {
      background-color: #7b86fd !important;
      border-color: #7b86fd !important;
      color: #FFF !important;
    }
    
    &:active {
      background-color: #4751e3 !important;
      border-color: #4751e3 !important;
      color: #FFF !important;
    }
    
    &.is-disabled {
      color: #c0c4cc !important;
      background-color: #f5f7fa !important;
      border-color: #e4e7ed !important;
      cursor: not-allowed !important;
      
      &:hover,
      &:focus {
        color: #c0c4cc !important;
        background-color: #f5f7fa !important;
        border-color: #e4e7ed !important;
      }
    }
  }
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.header-button {
  color: white;
  background-color: #325fac;
  font-size: rem(14);
  border-radius: rem(4);
  width: rem(88);
  height: rem(28);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background-color: rgb(91, 127, 189);
  }
  
  &:active {
    background-color: rgb(45, 86, 155);
  }
}

:deep(.el-table) {
  font-size: rem(14);
  
  .el-table__header-wrapper th,
  .el-table__fixed .el-table__header-wrapper th,
  .el-table__fixed-right .el-table__header-wrapper th {
    background-color: #fafafa !important;
    color: rgba(0, 0, 0, 0.85) !important;
    font-size: rem(14) !important;
    font-weight: normal !important;
    border-bottom: rem(1) solid #e8e8e8 !important;
    height: 54px !important;
    padding: 0 !important;
    text-align: center !important;
  }
  
  .el-table__fixed-right-patch {
    background-color: #fafafa !important;
    height: 54px !important;
  }
  
  .el-table__fixed-right .el-table__header th {
    background-color: #fafafa !important;
    height: 54px !important;
  }
  
  .el-table__fixed-right .el-table__header {
    height: 54px !important;
  }
  
  .el-table__body-wrapper td,
  .el-table__fixed .el-table__body-wrapper td,
  .el-table__fixed-right .el-table__body-wrapper td {
    color: #666666 !important;
    font-size: rem(14) !important;
    border-bottom: rem(1) solid #e8e8e8 !important;
    height: 54px !important;
    padding: 0 !important;
    text-align: center !important;
    line-height: rem(22) !important;
  }
  
  .el-table__body tr:hover td,
  .el-table__fixed .el-table__body tr:hover td,
  .el-table__fixed-right .el-table__body tr:hover td {
    background-color: #f7f7f7 !important;
  }
  
  .selected-row td,
  .el-table__fixed .selected-row td,
  .el-table__fixed-right .selected-row td {
    background-color: #e6f7ff !important;
    height: 54px !important;
  }
  
  .selected-row:hover td,
  .el-table__fixed .selected-row:hover td,
  .el-table__fixed-right .selected-row:hover td {
    background-color: #e6f7ff !important;
    height: 54px !important;
  }
  
  &.el-table--border {
    border: rem(1) solid #e8e8e8;
    
    &::after {
      display: none;
    }
    
    &::before {
      display: none;
    }
  }
  
  .el-table__fixed {
    border-right: rem(1) solid #e8e8e8;
  }
  
  .el-table__fixed-right {
    border-left: rem(1) solid #e8e8e8;
  }
}
</style>
